<!-- AI.vue -->
<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <v-snackbar
          v-model="snackbar.show"
          :color="snackbar.color"
          :timeout="3000"
          top
        >
          {{ snackbar.message }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar.show = false"
              >ปิด</v-btn
            >
          </template>
        </v-snackbar>

        <v-dialog v-model="isShowHistoryDialog" max-width="1300">
          <v-card class="tw-p-4" style="height: auto">
            <div
              class="tw-pb-4 tw-my-4 tw-text-center tw-border-b tw-border-gray-500 tw-mx-4 tw-font-bold"
            >
              ข้อมูลการใช้งานรวม
            </div>
            <div
              class="tw-mx-4 tw-mt-4 tw-max-h-132 tw-flex tw-justify-between"
            >
              <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                v-model="selectedMonth"
                :items="selectedChatGptActivityLog"
                item-value="id"
                item-text="id"
                label="Select Month"
              ></v-select>
            </div>
            <div
              class="tw-mx-4 tw-mt-4 tw-overflow-y-scroll tw-max-h-132 tw-h-146"
            >
              <v-data-table
                class="nowrap"
                hide-default-footer
                :items-per-page="-1"
                :headers="[
                  { text: 'Date', value: 'id' },
                  { text: 'PDF File', value: 'countDetails' },
                  { text: 'Input Tokens', value: 'tokenPrompt' },
                  { text: 'Output Tokens', value: 'tokenCompletion' },
                  { text: 'Total Tokens', value: 'tokenTotal' },
                ]"
                :loading="loading"
                loading-text="Loading... Please wait"
                :items="formatNumbers(selectedDateChatGptActivityLog)"
                item-key="id"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                show-expand
              >
                <template v-slot:expanded-item="{ item }">
                  <td :colspan="6" class="expanded-item-td">
                    <v-data-table
                      hide-default-footer
                      dense
                      class="elevation-1"
                      :headers="[
                        {
                          text: 'Model Version',
                          value: 'modelVersion',
                          class: 'my-header-style',
                        },
                        {
                          text: 'PDF File',
                          value: 'countDetails',
                          class: 'my-header-style',
                        },
                        {
                          text: 'Input Tokens',
                          value: 'tokenPrompt',
                          class: 'my-header-style',
                        },
                        {
                          text: 'Output Tokens',
                          value: 'tokenCompletion',
                          class: 'my-header-style',
                        },
                        {
                          text: 'Total Tokens',
                          value: 'tokenTotal',
                          class: 'my-header-style',
                        },
                      ]"
                      :items="formatNumbers(item.modelData)"
                      item-key="modelVersion"
                      full-width
                      :item-class="rowClass"
                    ></v-data-table>
                  </td>
                </template>
              </v-data-table>
            </div>
        <!-- selectedChatGptActivityLog {{ selectedChatGptActivityLog }}

        selectedDateChatGptActivityLog {{  selectedDateChatGptActivityLog }} -->

            <div class="tw-mx-4 tw-mt-4 tw-border-t tw-py-4">
              <v-row
                justify="end"
                v-for="model in modelData"
                :key="model.modelVersion"
                class="pa-0 ma-0"
              >
                <v-col cols="12" sm="6" md="4" class="tw-py-0">
                  <v-text-field
                    label="Model"
                    readonly
                    :value="model?.modelVersion"
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Total PDFs"
                    readonly
                    :value="model.countDetails?.toLocaleString()"
                    reverse
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Total Inputs"
                    readonly
                    :value="model.tokenPrompt?.toLocaleString()"
                    reverse
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Total Outputs"
                    readonly
                    :value="model.tokenCompletion?.toLocaleString()"
                    reverse
                    outlined
                    class="text-right"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="tw-py-0">
                  <v-text-field
                    label="Net Tokens"
                    readonly
                    :value="model.tokenTotal?.toLocaleString()"
                    class="text-right"
                    outlined
                    reverse
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <div class="tw-py-4 tw-mx-4 tw-flex tw-mt-2 tw-border-gray-500">
              <v-btn outlined @click="isShowHistoryDialog = false">ปิด</v-btn>
            </div>
          </v-card>
        </v-dialog>

        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text>
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>

             <div v-if="isStaff" class="tw-mx-5 tw-font-bold tw-text-lg tw-text-black tw-tracking-wide">
              <div class="tw-flex tw-justify-between tw-items-center">
                <span class="tw-font-bold tw-text-lg tw-text-black tw-tracking-wide"> ตั้งค่าการเชื่อมต่อ API</span>
                <div class="tw-flex tw-gap-4">
                  <v-btn @click="showHistoryDialog" text outlined color="brown" :disabled="isInitializing">
                    <v-icon left>mdi-history</v-icon>
                    ข้อมูลการใช้งานรวม
                  </v-btn>
                </div>
              </div>
            </div>
            <div v-if="isStaff" class="tw-flex tw-mx-8 tw-mt-8">
              <v-row class="tw-flex tw-gap-4">
                <v-col cols="4" class="ma-0 pa-0">
                  <v-text-field
                    v-model="OpenAIapiKey"
                    outlined
                    dense
                    :type="showKeyOpenAI ? 'text' : 'password'"
                    :append-icon="showKeyOpenAI ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="toggleshowKeyOpenAI"
                    label="OpenAI API Key"
                    persistent-placeholder
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="ma-0 pa-0">
                  <v-btn color="primary" :loading="isSavingOpenAIApiKey" :disabled="!OpenAIapiKey" @click="saveOpenAIApiKey" class="tw-mr-4">
                    <v-icon left>mdi-content-save</v-icon>
                    <span class="ml-2">บันทึก</span>
                  </v-btn>
                  <v-btn color="info" :loading="isTestingConnectionOpenAI" :disabled="!OpenAIapiKey" outlined @click="testConnectionOpenAI">
                    <v-icon left>mdi-router-wireless</v-icon>
                    <span class="ml-2">ทดสอบ</span>
                  </v-btn>
                </v-col>
              </v-row>
            </div>

             <div v-if="isStaff" class="tw-flex tw-mx-8 tw-mt-8">
              <v-row class="tw-flex tw-gap-4">
                <v-col cols="4" class="ma-0 pa-0">
                  <v-text-field
                    v-model="GoogleAIapiKey"
                    outlined
                    dense
                    :type="showKeyGoogleAI ? 'text' : 'password'"
                    :append-icon="showKeyGoogleAI ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="toggleShowKeyGoogleAI"
                    label="GoogleAI API Key"
                    persistent-placeholder
                  ></v-text-field>
                </v-col>
                <v-col cols="4" class="ma-0 pa-0">
                  <v-btn color="primary" :loading="isSavingGoogleAIApiKey" :disabled="!GoogleAIapiKey" @click="saveGoogleAIApiKey" class="tw-mr-4">
                    <v-icon left>mdi-content-save</v-icon>
                    <span class="ml-2">บันทึก</span>
                  </v-btn>
                  <v-btn color="info" :loading="isTestingConnectionGoogleAI" :disabled="!GoogleAIapiKey" outlined @click="testConnectionOpenAIGoogleAI">
                    <v-icon left>mdi-router-wireless</v-icon>
                    <span class="ml-2">ทดสอบ</span>
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <div v-if="isStaff" class="tw-px-3 tw-mb-2">

            
                      <div
                        class="tw-flex tw-items-center tw-justify-between tw-mt-10"
                      >
                        <span
                          class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide tw-mb-2"
                          >ตั้งค่า Text OCR</span
                        >
                      </div>

                      <v-row
                        class="tw-mt-4 tw-mx-4 tw-rounded-lg tw-p-4 model_wrapper"
                      >
                        <v-col cols="12" sm="12">
                          <h4
                            class="tw-text-lg tw-font-bold tw-text-black tw-tracking-wide tw-mb-2"
                          >
                            บริการ OCR
                          </h4>
                          <v-chip-group
                            v-model="currentSelectedOcrService"
                            mandatory
                            disabled
                            active-class="primary"
                            :class="{ 'disabled-chip-group': !isEditMode }"
                          >
                            <v-chip
                              v-for="service in ocrServiceOptions"
                              :key="service.value"
                              :value="service.value"
                              outlined
                              :color="
                                currentSelectedOcrService === service.value
                                  ? 'primary'
                                  : ''
                              "
                            >
                              <v-icon
                                v-if="
                                  currentSelectedOcrService === service.value
                                "
                                color="primary"
                                >mdi-check</v-icon
                              >
                              <img
                                :src="service.icon"
                                class="tw-w-6 tw-h-6 tw-object-contain tw-mr-2 tw-ml-1"
                              />
                              {{ service.text }}
                            </v-chip>
                          </v-chip-group>
                          <div class="tw-flex tw-items-center tw-mt-2">
                            <div
                              class="tw-w-4 tw-h-4 tw-bg-light-green tw-rounded-full tw-mr-2"
                            ></div>
                            <div
                              class="tw-text-sm tw-text-gray-500-500 tw-flex tw-items-center"
                            >
                              <span>คุณเลือก:</span>
                              <img
                                :src="
                                  currentSelectedOcrService
                                    ? '/images/python.png'
                                    : '/images/google-logo.png'
                                "
                                class="tw-w-6 tw-h-6 tw-object-contain tw-mr-2 tw-ml-1"
                              />
                              <span>{{
                                currentSelectedOcrService
                                  ? "Python"
                                  : "Google Vision"
                              }}</span>
                            </div>
                          </div>
                        </v-col>
                      </v-row>

                      <div
                        class="tw-flex tw-items-center tw-justify-between tw-mt-10"
                      >
                        <span
                          class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide tw-mb-2"
                          >ตั้งค่า Model</span
                        >
              <div class="mr-1 mb-5">
                <v-btn
                  v-if="!isEditMode"
                  @click="toggleEditMode"
                  class="tw-text-xl tw-mr-4"
                  color="warning"
                >
                  แก้ไข
                </v-btn>

                <v-btn
                  v-if="isEditMode"
                  @click="saveSettingModel"
                  class="tw-text-xl tw-mr-4"
                  color="primary"
                  :loading="isSavingSettingModel"
                >
                  บันทึก
                </v-btn>

                 <v-btn
                  v-if="isEditMode"
                  @click="toggleCancel"
                  class="tw-text-xl tw-mr-4"
                  color=""
                >
                  ยกเลิก
                </v-btn>
              </div>
                      </div>

                      

                      <v-row
                        class="tw-mt-4 tw-mx-4 tw-rounded-lg tw-p-4 model_wrapper"
                      >
                        <v-col cols="12" sm="12">
                          <h4
                            class="tw-text-lg tw-font-bold tw-text-black tw-tracking-wide tw-mb-2"
                          >
                            Model หลัก
                          </h4>
                          <v-chip-group
                            v-model="primaryModelIndex"
                            mandatory
                            return-object
                            active-class="primary"
                            :disabled="!isEditMode"
                            :class="{ 'disabled-chip-group': !isEditMode }"
                          >
                            <v-chip
                              v-for="model in modelOptions"
                              :key="model.value"
                              :value="model"
                              outlined
                              :color="
                                primaryModelIndex === model.value
                                  ? 'primary'
                                  : ''
                              "
                            >
                              <v-icon
                                v-if="primaryModelIndex === model.value"
                                color="primary"
                                >mdi-check</v-icon
                              >
                              {{ model.text }}
                            </v-chip>
                          </v-chip-group>
                          <div class="tw-flex tw-items-center tw-mt-2">
                            <div
                              class="tw-w-4 tw-h-4 tw-bg-light-green tw-rounded-full tw-mr-2"
                            ></div>
                            <span class="tw-text-sm tw-text-gray-500-500"
                              >คุณเลือก:
                              <!-- {{ currentVendorvendorOpenAiModel1 }} -->
                              </span
                            >
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <h4
                            class="tw-text-lg tw-font-bold tw-text-black tw-tracking-wide tw-mb-2"
                          >
                            Model สำรอง
                          </h4>
                          <v-chip-group
                            v-model="secondaryModelIndex"
                            mandatory
                            return-object
                            active-class="primary"
                            :disabled="!isEditMode"
                            :class="{ 'disabled-chip-group': !isEditMode }"
                          >
                            <v-chip
                              v-for="model in modelOptions"
                              :key="model.value"
                              :value="model"
                              outlined
                              :color="
                                secondaryModelIndex === model.value
                                  ? 'primary'
                                  : ''
                              "
                            >
                              <v-icon
                                v-if="secondaryModelIndex === model.value"
                                color="primary"
                                >mdi-check</v-icon
                              >
                              {{ model.text }}
                            </v-chip>
                          </v-chip-group>
                          <div class="tw-flex tw-items-center tw-mt-2">
                            <div
                              class="tw-w-4 tw-h-4 tw-bg-light-green tw-rounded-full tw-mr-2"
                            ></div>
                            <span class="tw-text-sm tw-text-gray-500-500"
                              >คุณเลือก:
                              <!-- {{ currentVendorvendorOpenAiModel2 }} -->
                              </span
                            >
                          </div>
                        </v-col>
                      </v-row>
                    </div>
<!-- -------------------------------------------------------------------------------------- -->
            <!-- Prompts -->
            <div class="tw-mx-5 tw-mt-20">
              <div class="tw-flex tw-justify-between tw-items-center">
                <span
                  class="tw-font-bold tw-text-lg tw-text-black tw-tracking-wide"
                  >จัดการคำสั่ง Prompt</span
                >
                <div class="tw-flex tw-gap-2">
                  <v-btn outlined color="primary" :disabled="savingChanges" @click="openNewPromptDialog">
                    <v-icon left>mdi-plus</v-icon>
                    เพิ่มคำสั่ง
                  </v-btn>
                  <v-btn
                    color="success"
                    :loading="savingChanges"
                    :disabled="!hasUnsavedChanges || savingChanges"
                    @click="savePromptChanges"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    บันทึก
                  </v-btn>
                </div>
              </div>
            </div>
            
            <div v-if="!isInitializing">
              <!-- Prompt Type Filter -->
              <v-card-text class="tw-pb-0 tw-px-8">
                <v-chip-group
                  v-model="selectedPromptTypeFilter"
                  mandatory
                  @change="filterPromptsByType"
                >
                  <v-chip
                    filter
                    outlined
                    value="all"
                    class="tw-font-medium"
                    :color="selectedPromptTypeFilter === 'all' ? 'primary' : ''"
                  >
                    ทั้งหมด
                  </v-chip>
                  <v-chip
                    filter
                    outlined
                    :value="1"
                    class="tw-font-medium"
                    :color="selectedPromptTypeFilter === '1' ? 'indigo' : ''"
                  >
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Invoice
                  </v-chip>
                  <v-chip
                    filter
                    outlined
                    :value="2"
                    class="tw-font-medium"
                    :color="selectedPromptTypeFilter === '2' ? 'black' : ''"
                  >
                    <v-icon left small>mdi-credit-card-outline</v-icon>
                    Credit Advice
                  </v-chip>
                </v-chip-group>
              </v-card-text>

              <v-tabs v-model="currentTabIndex" class="tw-mt-2">
                <v-row class="tw-px-9">
                  <v-tab 
                    v-for="prompt in filteredPrompts" 
                    :key="prompt.promptId"
                    :class="[getPromptTypeClass(prompt.promptType), prompt.isActive ? 'active-prompt' : '']"
                  >
                    <v-icon small left :color="getPromptTypeColor(prompt.promptType)">
                      {{ getPromptTypeIcon(prompt.promptType) }}
                    </v-icon>
                    <span class="tw-relative">
                      {{ prompt.promptName }}
                      <v-badge
                        v-if="prompt.isActive"
                        color="success"
                        dot
                        left
                        class="active-badge"
                      ></v-badge>
                    </span>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on" @click.stop>
                          <v-icon small>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item 
                          v-if="!prompt.isActive"
                          @click="setActivePrompt(prompt)"
                          :disabled="isActivatingPrompt"
                        >
                          <v-list-item-title class="tw-flex tw-items-center">
                            <v-icon left small color="success">mdi-check-circle</v-icon>
                            ตั้งค่าเป็นใช้งาน
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="openEditTypeDialog(prompt)">
                          <v-list-item-title class="tw-flex tw-items-center">
                            <v-icon left small color="primary">mdi-pencil</v-icon>
                            แก้ไขประเภท
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="openDeleteDialog(prompt)">
                          <v-list-item-title class="tw-flex tw-items-center tw-text-error">
                            <v-icon left small color="error">mdi-delete</v-icon>
                            ลบคำสั่ง
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-tab>
                </v-row>

                <v-tab-item 
                  v-for="prompt in filteredPrompts" 
                  :key="prompt.promptId"
                >
                  <v-card flat class="tw-pt-4 tw-px-2">
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="6" lg="3">
                          <v-select
                            :value="prompt.promptType || ''"
                            @input="(value) => updatePromptType(prompt.promptId, value)"
                            :items="promptTypes"
                            item-text="text"
                            item-value="value"
                            label="ประเภทคำสั่ง"
                            outlined
                            dense
                            return-object
                            class="tw-mb-4"
                          >
                            <template v-slot:selection="{ item }">
                              <div class="tw-flex tw-items-center">
                                <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                                {{ item.text }}
                              </div>
                            </template>
                            <template v-slot:item="{ item }">
                              <div class="tw-flex tw-items-center">
                                <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                                {{ item.text }}
                              </div>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="6" lg="3">
                          <v-card
                            class="tw-mb-4 tw-px-3 tw-py-2"
                            :color="prompt.isActive ? 'success lighten-5' : 'grey lighten-4'"
                            flat
                          >
                            <div class="tw-flex tw-justify-between tw-items-center">
                              <div>
                                <div class="tw-flex tw-items-center tw-mt-1">
                                  <v-icon small :color="prompt.isActive ? 'success' : 'grey'">
                                    {{ prompt.isActive ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                                  </v-icon>
                                  <span class="tw-ml-1 tw-text-sm">
                                    {{ prompt.isActive ? 'กำลังใช้งาน' : 'ไม่ใช้งาน' }}
                                  </span>
                                </div>
                              </div>
                              <v-btn
                                v-if="!prompt.isActive"
                                small
                                color="success"
                                outlined
                                :loading="isActivatingPrompt && activatingPromptId === prompt.promptId"
                                @click="setActivePrompt(prompt)"
                              >
                                เปิดใช้งาน
                              </v-btn>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-textarea
                            :value="prompt.promptText"
                            @input="(value) => updatePromptText(prompt.promptId, value)"
                            label="Prompt Text"
                            rows="35"
                            outlined
                            dense
                            persistent-placeholder
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </div>
            <div v-else>
              <v-skeleton-loader class="tw-w-96"
                type="list-item-two-line"
              ></v-skeleton-loader>
              <v-skeleton-loader
               class="tw-w-96"
                type="list-item-two-line"
              ></v-skeleton-loader>
              <v-skeleton-loader
               class="tw-w-162"
                type="list-item-two-line"
              ></v-skeleton-loader>
            </div>

          </v-card-text>
        </v-card>

        <v-dialog v-model="showDeleteDialog" max-width="400">
          <v-card>
            <v-card-title>ยืนยันการลบคำสั่ง</v-card-title>
            <v-card-text>
              คุณต้องการลบคำสั่ง "{{ promptToDelete?.promptName }}" ใช่หรือไม่?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDeleteDialog">ยกเลิก</v-btn>
              <v-btn
                color="error"
                :loading="deletingPrompt"
                @click="deletePrompt"
              >
                ลบ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showEditTypeDialog" max-width="400">
          <v-card>
            <v-card-title>แก้ไขประเภทคำสั่ง</v-card-title>
            <v-card-text>
              <v-select
                v-model="editingPromptType"
                :items="promptTypes"
                item-text="text"
                item-value="value"
                label="ประเภทคำสั่ง"
                outlined
                dense
                return-object
              >
                <template v-slot:selection="{ item }">
                  <div class="tw-flex tw-items-center">
                    <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </div>
                </template>
                <template v-slot:item="{ item }">
                  <div class="tw-flex tw-items-center">
                    <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </div>
                </template>
              </v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeEditTypeDialog">ยกเลิก</v-btn>
              <v-btn
                color="primary"
                @click="savePromptType"
              >
                บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showNewPromptDialog" max-width="500px">
          <v-card>
            <v-card-title>เพิ่มคำสั่งใหม่</v-card-title>
            <v-card-text>
              <v-text-field
                v-model="newPrompt.name"
                label="ชื่อคำสั่ง"
                outlined
                dense
                class="tw-mb-4"
              ></v-text-field>
              
              <v-select
                v-model="newPrompt.type"
                :items="promptTypes"
                item-text="text"
                item-value="value"
                label="ประเภทคำสั่ง"
                outlined
                dense
                return-object
              >
                <template v-slot:selection="{ item }">
                  <div class="tw-flex tw-items-center">
                    <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </div>
                </template>
                <template v-slot:item="{ item }">
                  <div class="tw-flex tw-items-center">
                    <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                    {{ item.text }}
                  </div>
                </template>
              </v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="closeNewPromptDialog"
                >ยกเลิก</v-btn
              >
              <v-btn
                color="primary"
                :loading="savingPrompt"
                :disabled="!newPrompt.name || savingPrompt"
                @click="addNewPrompt"
              >
                เพิ่ม
              </v-btn>
            </v-card-actions>
          </v-card>      
        </v-dialog>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import { mapState } from "vuex";
import _isEqual from "lodash/isEqual";
import _ from "lodash";
import fc from "@/firebaseConfig";

const gptModels = ["gpt-4o-mini", "gpt-4o"];

export default {
  name: "AI",
  components: { Admin },

  data: () => ({
    modelOptions: [
      { text: "GPT-4o", value: "gpt-4o",provider : 'OpenAI',image :'gpt.png'  },
      { text: "GPT-4o Mini", value: "gpt-4o-mini",provider : 'OpenAI',image :'gpt.png'  },
      { text: 'Gemini Flash 2.5', value: 'gemini-2.5-flash',provider : 'Google',image :'gg.png' },
      // { label: 'DeepSeek Reasoner', value: 'deepseek-reasoner',provider : 'Deepseek',image :'deepseek.png' },
      // { text: 'DeepSeek Chat', value: 'deepseek-chat',provider : 'Deepseek',image :'deepseek.png' },
      // { text: 'Claude Haiku 3.5', value: 'claude-3-5-haiku-latest',provider : 'Claude',image :'claude.png' },
      // { text: 'GPT-4.1 mini', value: 'gpt-4.1-mini',provider : 'OpenAI',image :'openai.png' },
      // { text: 'Gemini Pro 2.5', value: 'gemini-2.5-pro',provider : 'Google',image :'gg.png' },
      // { text: 'o3', value: 'o3',provider : 'OpenAI',image :'openai.png' },
      // { text: 'GPT-4.1', value: 'gpt-4.1',provider : 'OpenAI' ,image :'openai.png'},
    ],
    selectedMonth: "",
    isEditMode: false,
    isCancel: false,
    savingPrompt: false,
    savingChanges: false,
    singleExpand: true,
    expanded: [],
    modelData: [],
    snackbar: {
      show: false,
      message: "",
      color: "success",
    },
    items: [
      {
        text: "ตั้งค่า",
        disabled: false,
        to: { name: "Company.Settings" },
      },
      {
        text: "คำสั่ง Prompt",
        disabled: true,
      },
    ],
    currentTabIndex: 0,
    showKeyOpenAI:false,
    showKeyGoogleAI:false,
    showKey: false,
    // openAiKey: "",
    // googleAiKey: "",
    vendorSearch: "",
    isTestingConnectionOpenAI: false,
    isTestingConnectionGoogleAI: false,
    isSavingOpenAIApiKey: false,
    isSavingGoogleAIApiKey: false,
    isSavingSettingModel: false,
    showNewPromptDialog: false,
    showDeleteDialog: false,
    showEditTypeDialog: false,
    promptToDelete: null,
    promptToEdit: null,
    editingPromptType: null,
    deletingPrompt: false,
    isActivatingPrompt: false,
    activatingPromptId: null,
    companyID: null,
    newPrompt: {
      name: "",
      text: "",
      type: null,
      selectedVendors: [],
    },
    hasUnsavedChanges: false,
    originalPrompts: null,
    OpenAIapiKey: "",
    GoogleAIapiKey: "",
    SettingModel: "",
    isInitializing: true,
    selectedPromptTypeFilter: "all",
    promptTypes: [
      { text: "Invoice", value: 1, icon: "mdi-file-document-outline", color: "indigo" },
      { text: "Credit Advice", value: 2, icon: "mdi-credit-card-outline", color: "black" }
    ],
    ocrServiceOptions: [
      { text: "Google Vision", value: false, icon: "/images/google-logo.png" },
      { text: "Python", value: true, icon: "/images/python.png" },
    ],
    isShowHistoryDialog: false,
    currentSelectedOcrService: false,
    primaryModelIndex: "",
    secondaryModelIndex: "",
    vendorOpenAiModel1: gptModels[0],
    vendorOpenAiModel2: gptModels[1],
    isPython: false,
  }),
  created() {
    const companyID = this.$route.params.companyId;
    if (companyID) {
      this.$store.dispatch("user/getRoleUser", { companyId: companyID });
    }


    this.getChatGptActivityLog();
    this.selectedMonth = this.getCurrentMonth();

  },

  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
      userCompany: (state) => state.user.userCompany,
      loading: (state) => state.companies.loading,
      selectedCompanyApVendors: (state) =>
        state.companies.selectedCompanyApVendors,
      selectedDateChatGptActivityLog: (state) =>
        state.companies.selectedDateChatGptActivityLog,
      prompts: (state) => state.companies.selectedCompanyApPrompts,
      selectedChatGptActivityLog: (state) =>
        state.companies.selectedChatGptActivityLog,
    }),
    isCompanyAdmin() {
      return this.userCompany?.isAdmin;
    },
    isStaff() {
      return this.userCompany?.user?.isEngineer || this.userCompany?.isDeveloper;
    },
    // currentPromptId() {
    //   return this.filteredPrompts[this.currentTabIndex]?.promptId || "";
    // },
    // filteredVendors() {
    //   return this.selectedCompanyApVendors.filter(
    //     (vendor) =>
    //       (vendor.venName || "")
    //         .toLowerCase()
    //         .includes((this.vendorSearch || "").toLowerCase()) && vendor.promptId === this.currentPromptId
    //   );
    // },
    filteredPrompts() {
      if (this.selectedPromptTypeFilter === "all") return this.prompts;
      return this.prompts.filter(prompt => prompt.promptType === Number(this.selectedPromptTypeFilter));
    },
  },

  watch: {
    selectedCompany: {
      handler(newVal) {
        if (newVal) {
          this.OpenAIapiKey = newVal.openAiKey || "";
          this.GoogleAIapiKey = newVal.googleAIapiKey || "";
          this.primaryModelIndex = newVal.models?.mainmodel|| "";
          this.secondaryModelIndex = newVal.models?.submodel|| "";
        }
      },
      immediate: true,
    selectedMonth(newVal, oldVal) {
      console.log("Selected month changed:", newVal);
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getDateListChatGptActivityLog", {
        companyId,
        newVal,
      });
      this.modelData = this.findModelData(newVal);
    },
    selectedChatGptActivityLog(newVal, oldVal) {
      console.log("list month", this.selectedChatGptActivityLog.length);
      this.modelData = this.findModelData(this.selectedMonth);
    },
    },
    // currentTabIndex(val) {
    //   if (this.selectedCompanyAutoDocConfig.length > 0) {
    //     this.searchKeywordsDsp =
    //       this.selectedCompanyAutoDocConfig[val].searchKeywords?.join("||");
    //     this.specialSearchKeywordsDsp =
    //       this.selectedCompanyAutoDocConfig[val].specialSearchKeywords?.join(
    //         "||"
    //       );
    //     this.currentVendor = Object.assign(
    //       {},
    //       this.selectedCompanyAutoDocConfig[val]
    //     );
    //     // Ensure isPython is initialized
    //     this.currentVendor.isPython = this.currentVendor.isPython ?? false;
    //     this.currentVendorCopy = Object.assign({}, this.currentVendor);

    //     // Update model indices when tab changes
    //     this.primaryModelIndex =
    //       this.mainModel || this.modelOptions[0].value;
    //     this.secondaryModelIndex =
    //       this.subModel || this.modelOptions[1].value;

    //     // Update OCR service based on currentVendor
    //     this.currentSelectedOcrService = this.currentVendor.isPython || false;

    //     this.isEditPrompt = false;
    //     this.currentVendorModelTab = 0;
    //   }
    // // },
    // selectedCompanyAutoDocConfig(val) {
    //   if (val && val.length > 0) {
    //     this.searchKeywordsDsp =
    //       val[this.currentTabIndex].searchKeywords?.join("||");
    //     this.specialSearchKeywordsDsp =
    //       val[this.currentTabIndex].specialSearchKeywords?.join("||");
    //     this.currentVendor = Object.assign({}, val[this.currentTabIndex]);
    //     // Ensure isPython is initialized
    //     this.currentVendor.isPython = this.currentVendor.isPython ?? false;
    //     this.currentVendorCopy = Object.assign({}, this.currentVendor);

    //     // Initialize model indices based on currentVendor
    //     this.primaryModelIndex =
    //       this.currentVendor.vendorOpenAiModel1 || this.modelOptions[0].value;
    //     this.secondaryModelIndex =
    //       this.currentVendor.vendorOpenAiModel2 || this.modelOptions[1].value;

    //     // Initialize OCR service based on currentVendor
    //     this.currentSelectedOcrService = this.currentVendor.isPython || false;

    //     this.isEditPrompt = false;
    //   }
    // },
    prompts: {
      handler(newVal) {
        if (this.originalPrompts && !_isEqual(newVal, this.originalPrompts)) {
          this.hasUnsavedChanges = true;
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.init();
  },

  methods: {
     toggleEditMode() {
      this.isEditMode = true;
    },
    toggleCancel() {
     this.isEditMode = false;
    },
    fetchDateData() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getDateListChatGptActivityLog", {
        companyId,
        newVal: this.selectedMonth,
      });
    },
    showHistoryDialog() {
      this.isShowHistoryDialog = true;
    },
    findModelData(month) {
      const selectedData = this.selectedChatGptActivityLog.find(
        (item) => item.id === this.selectedMonth
      );
      return selectedData ? selectedData.modelData : [];
    },
    getCurrentMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const formattedMonth = month < 10 ? `0${month}` : `${month}`;
      return `${year}-${formattedMonth}`;
    },
    getChatGptActivityLog() {
      console.log("start", this.selectedChatGptActivityLog);
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/getChatGptActivityLog", { companyId });
    },
    formatNumbers(data) {
      return data.map((item) => ({
        ...item,
        countDetails: item.countDetails.toLocaleString(),
        tokenPrompt: item.tokenPrompt.toLocaleString(),
        tokenCompletion: item.tokenCompletion.toLocaleString(),
        tokenTotal: item.tokenTotal.toLocaleString(),
      }))},
    getPromptTypeClass(type) {
      if (type === 1) return "prompt-type-invoice";
      if (type === 2) return "prompt-type-credit";
      return "";
    },
    
    getPromptTypeIcon(type) {
      if (type === 1) return "mdi-file-document-outline";
      if (type === 2) return "mdi-credit-card-outline";
      return "mdi-help-circle-outline";
    },
    
    getPromptTypeColor(type) {
      if (type === 1) return "indigo";
      if (type === 2) return "black";
      return "grey";
    },
    
    filterPromptsByType() {
      this.currentTabIndex = 0;
    },
    
    copyPromptId(promptId) {
      navigator.clipboard.writeText(promptId);
      this.notify("success", "คัดลอก ID คำสั่งสำเร็จ");
    },
    
    openEditTypeDialog(prompt) {
      this.promptToEdit = prompt;
      this.editingPromptType = this.promptTypes.find(t => t.value === prompt.promptType) || this.promptTypes[0];
      this.showEditTypeDialog = true;
    },
    
    closeEditTypeDialog() {
      this.promptToEdit = null;
      this.editingPromptType = null;
      this.showEditTypeDialog = false;
    },
    
    async savePromptType() {
      if (this.promptToEdit && this.editingPromptType) {
        this.updatePromptType(this.promptToEdit.promptId, this.editingPromptType);
        this.closeEditTypeDialog();
        
        // If the changes resulted in an inconsistent state, fix it immediately
        await this.ensureActivePromptsPerType();
        
        this.notify("success", "อัปเดตประเภทคำสั่งสำเร็จ");
      }
    },
    
    updatePromptType(promptId, value) {
      // Get the current prompt
      const currentPrompt = this.prompts.find(p => p.promptId === promptId);
      
      // Check if we're changing the type
      if (currentPrompt && currentPrompt.promptType !== Number(value.value)) {
   
        const newType = value.value;
        const oldType = currentPrompt.promptType;
        
        // Start with a copy of the prompts
        let updatedPrompts = [...this.prompts];
        
        // Check if the prompt we're updating is active
        const isCurrentPromptActive = currentPrompt.isActive;
        
        // Check if there's already an active prompt of the new type
        const existingActivePrompt = this.prompts.find(p => 
          p.promptType === newType && 
          p.isActive && 
          p.promptId !== promptId
        );
        
        // First pass: Update the type of the current prompt
        updatedPrompts = updatedPrompts.map(p => {
          if (p.promptId === promptId) {
            // If changing to a type that already has an active prompt,
            // this prompt should not be active
            const shouldBeActive = isCurrentPromptActive && !existingActivePrompt;
            return { 
              ...p, 
              promptType: newType,
              isActive: shouldBeActive 
            };
          }
          return p;
        });
        
        // If the current prompt was active, and there's no active prompt of the old type left,
        // activate the first prompt of the old type if one exists
        if (isCurrentPromptActive) {
          const oldTypePromptsRemaining = updatedPrompts.filter(p => 
            p.promptType === oldType && p.promptId !== promptId
          );
          
          if (oldTypePromptsRemaining.length > 0 && 
              !oldTypePromptsRemaining.some(p => p.isActive)) {
            // Activate the first prompt of the old type
            const firstOldTypePromptId = oldTypePromptsRemaining[0].promptId;
            updatedPrompts = updatedPrompts.map(p => {
              if (p.promptId === firstOldTypePromptId) {
                return { ...p, isActive: true };
              }
              return p;
            });
          }
        }
        
        this.$store.commit(
          "companies/setSelectedCompanyApPrompts",
          updatedPrompts
        );
        this.handlePromptChange();
        
        // Notify the user about the active status change if needed
        if (isCurrentPromptActive && existingActivePrompt) {
          this.notify(
            "info", 
            `ประเภทคำสั่งถูกเปลี่ยน และ "${existingActivePrompt.promptName}" ยังคงเป็นคำสั่งที่ใช้งานสำหรับประเภทนี้`
          );
        }
      } else {
        // If the type isn't changing, just update as normal
        const updatedPrompts = this.prompts.map((p) => {
          if (p.promptId === promptId) {
            return { ...p, promptType: value.value };
          }
          return p;
        });
        this.$store.commit(
          "companies/setSelectedCompanyApPrompts",
          updatedPrompts
        );
        this.handlePromptChange();
      }
    },
    
    async deletePrompt() {
      try {
        this.deletingPrompt = true;
        await this.$store.dispatch("companies/deletePrompt", {
          companyId: this.$route.params.companyId,
          promptId: this.promptToDelete.promptId,
        });
        this.notify("success", "ลบคำสั่งสำเร็จ");
        this.closeDeleteDialog();
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการลบคำสั่ง");
      } finally {
        this.deletingPrompt = false;
      }
    },
    
    notify(type, message) {
      this.snackbar = {
        show: true,
        message,
        color: type,
      };
    },
    
    openDeleteDialog(prompt) {
      this.promptToDelete = prompt;
      this.showDeleteDialog = true;
    },

    closeDeleteDialog() {
      this.promptToDelete = null;
      this.showDeleteDialog = false;
    },

    async init() {
      this.isInitializing = true
      const companyId = this.$route.params.companyId;
      if (companyId) {
        try {
          await Promise.all([
            this.$store.dispatch("user/getRoleUser", { companyId }),
            this.$store.dispatch("companies/fetchPrompts", { companyId }),
            this.fetchVendors(companyId),
          ]);
          
          // Ensure we have one active prompt per type if prompts exist for that type
          await this.ensureActivePromptsPerType();
          
          this.originalPrompts = _.cloneDeep(this.prompts);
        } catch (error) {
          this.notify("error", "เกิดข้อผิดพลาดในการดึงข้อมูล");
        }
      }
      this.isInitializing = false
    },
    
    async ensureActivePromptsPerType() {
      // Group prompts by type
      const promptsByType = _.groupBy(this.prompts, 'promptType');
      
      // Check each type to ensure there's exactly one active prompt
      let updatedPrompts = [...this.prompts];
      let hasChanges = false;
      
      for (const [type, prompts] of Object.entries(promptsByType)) {
        if (prompts.length > 0) {
          // Count active prompts for this type
          const activePrompts = prompts.filter(p => p.isActive);
          
          if (activePrompts.length === 0) {
            // No active prompts for this type, activate the first one
            const firstPromptId = prompts[0].promptId;
            updatedPrompts = updatedPrompts.map(p => {
              if (p.promptId === firstPromptId) {
                hasChanges = true;
                return { ...p, isActive: true };
              }
              return p;
            });
          } else if (activePrompts.length > 1) {
            // Multiple active prompts, keep only the first one active
            const keepActiveId = activePrompts[0].promptId;
            updatedPrompts = updatedPrompts.map(p => {
              if (p.promptType === type && p.isActive && p.promptId !== keepActiveId) {
                hasChanges = true;
                return { ...p, isActive: false };
              }
              return p;
            });
          }
        }
      }
      
      if (hasChanges) {
        // Update store with corrected active states
        this.$store.commit(
          "companies/setSelectedCompanyApPrompts",
          updatedPrompts
        );
        
        // Save changes to backend
        await this.$store.dispatch("companies/updatePrompts", {
          companyId: this.$route.params.companyId,
          prompts: updatedPrompts,
        });
      }
    },

    async fetchVendors(companyId) {
      const vendorsRef = await fc.companies
        .doc(companyId)
        .collection("PurchaseInvoiceVendors")
        .get();

      const vendors = vendorsRef.docs.map((doc) => ({
        vendorId: doc.id,
        ...doc.data(),
      }));

      this.$store.commit("companies/setSelectedCompanyApVendors", vendors);
    },
    
    updatePromptText(promptId, value) {
      const updatedPrompts = this.prompts.map((p) => {
        if (p.promptId === promptId) {
          return { ...p, promptText: value };
        }
        return p;
      });
      this.$store.commit(
        "companies/setSelectedCompanyApPrompts",
        updatedPrompts
      );
      this.handlePromptChange();
    },

    toggleShowKey() {
      this.showKey = !this.showKey;
    },
    toggleshowKeyOpenAI() {
      this.showKeyOpenAI = !this.showKeyOpenAI;
    },
    toggleShowKeyGoogleAI() {
      this.showKeyGoogleAI = !this.showKeyGoogleAI
    },

    async testConnectionOpenAI() {
      this.isTestingConnectionOpenAI = true;
      try {
        const response = await fetch("https://api.openai.com/v1/models", {
          headers: { Authorization: `Bearer ${this.OpenAIapiKey}` },
        });
        if (response.ok) {
          this.notify("success", "การเชื่อมต่อ OpenAIapiKey สำเร็จ");
        } else {
          throw new Error("Connection failed");
        }
      } catch (error) {
        this.notify("error", "การเชื่อมต่อล้มเหลว กรุณาตรวจสอบ OpenAI API Key");
      } finally {
        this.isTestingConnectionOpenAI = false;
      }
    },

    async testConnectionOpenAIGoogleAI() {
      this.isTestingConnectionGoogleAI = true;
      const params = {
    "contents":[
    {"parts":[{
      "text":"hello" 
          
    }]}
  ],
  "generationConfig":{
    "maxOutputTokens":100,
    "temperature":0.8
  }        
};
      const options = {
    method: 'POST',
    body: JSON.stringify(params)
};
      try {
        const response = await  fetch(`https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key= ${this.GoogleAIapiKey}`,options, {
         
        });
         if (response.ok) {
          this.notify("success", "การเชื่อมต่อ GoogleAIapiKey สำเร็จ");
        } else {
          throw new Error("Connection failed");
        }
      } catch (error) {
        this.notify("error", "การเชื่อมต่อล้มเหลว กรุณาตรวจสอบ GoogleAI API Key");
      } finally {
        this.isTestingConnectionGoogleAI = false;
      }
    },
    async saveOpenAIApiKey() {
      this.isSavingOpenAIApiKey = true;
      console.log("ttttttttttttttttttttttttt")
      try {
        console.log("yyyyyyyyyyyyyyyyyyyyyyyyy")
        await this.$store.dispatch("companies/updateOpenAIApiKey", {
          companyId: this.$route.params.companyId,
          OpenAIapiKey: this.OpenAIapiKey,
        });
        console.log("55555555555555555555555555")
        this.notify("success", "บันทึก OpenAIapiKey สำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึก OpenAI Key");
      } finally {
        this.isSavingOpenAIApiKey = false;
      }
    },
    async saveGoogleAIApiKey() {
      this.isSavingGoogleAIApiKey = true;
      try {
        await this.$store.dispatch("companies/updateGoogleAIApiKey", {
          companyId: this.$route.params.companyId,
          GoogleAIapiKey: this.GoogleAIapiKey,
        });
        this.notify("success", "บันทึก GoogleAIapiKey สำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึก GoogleAI Key");
      } finally {
        this.isSavingGoogleAIApiKey = false;
      }
    },
    async saveSettingModel() {
      this.isSavingSettingModel = true;
      try {
        await this.$store.dispatch("companies/updateSettingModel", {
          companyId: this.$route.params.companyId,
          primaryModelIndex: this.primaryModelIndex,
          secondaryModelIndex: this.secondaryModelIndex
        });
        this.notify("success", "บันทึก Model สำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึก GoogleAI Key");
      } finally {
        this.isSavingSettingModel = false;
      }
    },

    openNewPromptDialog() {
      this.newPrompt = {
        name: "",
        text: "",
        type: this.promptTypes[0],
        selectedVendors: [],
      };
      this.showNewPromptDialog = true;
    },

    closeNewPromptDialog() {
      this.showNewPromptDialog = false;
      this.newPrompt = {
        name: "",
        text: "",
        type: null,
        selectedVendors: [],
      };
    },

    async setActivePrompt(prompt) {
      try {
        this.isActivatingPrompt = true;
        this.activatingPromptId = prompt.promptId;
        
        // Check if there's already an active prompt of this type
        const currentActivePrompt = this.prompts.find(p => 
          p.promptType === prompt.promptType && p.isActive
        );
        
        // Deactivate the current active prompt of this type
        let updatedPrompts = [...this.prompts];
        if (currentActivePrompt) {
          updatedPrompts = updatedPrompts.map(p => {
            if (p.promptId === currentActivePrompt.promptId) {
              return { ...p, isActive: false };
            }
            return p;
          });
        }
        
        // Activate the new prompt
        updatedPrompts = updatedPrompts.map(p => {
          if (p.promptId === prompt.promptId) {
            return { ...p, isActive: true };
          }
          return p;
        });
        
        // Update store
        this.$store.commit(
          "companies/setSelectedCompanyApPrompts",
          updatedPrompts
        );
        
        // Save changes
        await this.$store.dispatch("companies/updatePrompts", {
          companyId: this.$route.params.companyId,
          prompts: updatedPrompts,
        });
        
        this.originalPrompts = _.cloneDeep(updatedPrompts);
        this.hasUnsavedChanges = false;
        this.notify("success", "ตั้งค่าคำสั่งเป็นใช้งานสำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการตั้งค่าคำสั่ง");
      } finally {
        this.isActivatingPrompt = false;
        this.activatingPromptId = null;
      }
    },
    
    async addNewPrompt() {
      try {
        this.savingPrompt = true;
        
        // Check if we should automatically set this prompt as active
        // This happens if there are no other prompts of this type
        const existingPromptsOfType = this.prompts.filter(p => 
          p.promptType === this.newPrompt.type.value
        );
        const shouldSetActive = existingPromptsOfType.length === 0;
        
        const newPrompt = {
          promptName: this.newPrompt.name,
          promptText: "",
          promptType: this.newPrompt.type.value,
          isActive: shouldSetActive,
          selectedVendors: [],
        };

        await this.$store.dispatch("companies/addPrompt", {
          companyId: this.$route.params.companyId,
          prompt: newPrompt,
        });

        this.closeNewPromptDialog();
        this.notify("success", shouldSetActive ? 
          "เพิ่มคำสั่งสำเร็จและตั้งเป็นใช้งาน" : 
          "เพิ่มคำสั่งสำเร็จ"
        );
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการเพิ่มคำสั่ง");
      } finally {
        this.savingPrompt = false;
      }
    },

    handlePromptChange() {
      this.hasUnsาedChanges = true;
    },

    handleVendorSelection() {
      this.hasUnsavedChanges = true;
    },

    async savePromptChanges() {
      try {
        this.savingChanges = true;
        
        // Ensure we have one active prompt per type before saving
        await this.ensureActivePromptsPerType();
        
        await this.$store.dispatch("companies/updatePrompts", {
          companyId: this.$route.params.companyId,
          prompts: this.prompts,
        });

        this.hasUnsavedChanges = false;
        this.originalPrompts = _.cloneDeep(this.prompts);
        this.notify("success", "บันทึกการเปลี่ยนแปลงสำเร็จ");
      } catch (error) {
        this.notify("error", "เกิดข้อผิดพลาดในการบันทึกการเปลี่ยนแปลง");
      } finally {
        this.savingChanges = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none;
  padding-right: 8px !important;

  .v-btn {
    margin-left: 8px;
  }
}

.prompt-type-invoice {
  border-left: 3px solid #3f51b5;
}

.prompt-type-credit {
  border-left: 3px solid #000000;
}

.active-prompt {
  background-color: #f5f9ff !important;
  font-weight: 500;
}

.active-badge {
  position: absolute;
  top: -4px;
  left: -10px;
}
.row-wrapper {
  padding-left: 20px;
}

.nowrap th,
td {
  white-space: nowrap;
}

.expanded-item-td {
  padding: 0;
}

.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  box-shadow: 0 0 0 0 !important;
}

.my-header-style {
  background: rgba(59, 130, 246, 0.5);
}

.row_Class {
  background-color: rgba(0, 0, 0, 0.12);
}

.vendor-avatar {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.img-show {
  width: 6rem;
  height: 6rem;
  object-fit: contain;
}
:deep(.el-tabs__item) {
  font-size: 16px !important;
}

:deep(.el-tabs__item.is-active) {
  color: #6ec39b !important;
  font-weight: 600 !important;
}

:deep(.el-tabs__item:hover) {
  color: #6ec39b90 !important;
  font-weight: 600 !important;
}

:deep(.el-tabs__active-bar) {
  background-color: #6ec39b !important;
}

.model_wrapper {
  background-color: #f0f0f025;
  border: 1px solid #b6b6b653;
}

.disabled-chip-group {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}
</style>